<template>
<footer class="footer mt-auto py-3">
  <div class="container">
    <span class="text-muted">&copy; {{ currentYear }} - Sanibel Cyber Tech</span>
  </div>
</footer>

</template>

<style scoped lang="scss">
  .footer {
    background-color: #f0f0f0;
  }
</style>

<script>
export default {
  data: function() {
    return {
      currentYear: new Date().getFullYear()
    }
  }

}
</script>